import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from 'react-visibility-sensor';

import gptw from "../../../../assets/img/home/hero/selo-large.webp";

import arrow from "../../../../assets/img/components/buttonBlue.webp";
import arrow2 from "../../../../assets/img/components/buttonBlue2.webp";
import arrow3 from "../../../../assets/img/components/buttonBlue3.webp";
import { CButton, CForm, CFormInput, CFormLabel, CFormText, CFormSelect } from "@coreui/react-pro";
import { useAlert } from "src/contexts/AlertContext";
import { sendRoadTransportEmail } from "src/services/sendRoadTransportEmail";
import { trackLead, trackWhatsApp, buildWhatsAppText } from "src/utils/tracking";

const DEFAULT_FORM_DATA = {
    name: '',
    email: '',
    phone: '',
    enterprise: '',
    type: '',
    weight: '',
    value: '',
    origin: '',
    destination: '',
    isLoadingResponse: false
};

function SectionOne({message}){

    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    const [formData, setFormData] = useState(DEFAULT_FORM_DATA)
    const [errors, setErrors] = useState({})

    const formatPhoneValue = (event) => {
    const formattedPhone = event.target.value
        .replace(/\D/g, '') // Remove todos os caracteres não numéricos
        .replace(/^(\d{2})(\d)/g, '($1) $2') // Adiciona parênteses em volta dos dois primeiros dígitos
        .replace(/(\d)(\d{4})$/, '$1-$2'); // Adiciona hífen entre o quinto e o sexto dígitos

    setFormData(prev => ({ ...prev, phone: formattedPhone }))
    }

    const {showAlert} = useAlert()

    const validateForm = () => {
        const newErrors = {}
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

        if (!formData.name || formData.name.trim().length < 3)
            newErrors.name = t("form_error_name")
        if (!formData.email || !emailRegex.test(formData.email.trim()))
            newErrors.email = t("form_error_email")
        if (!formData.phone || formData.phone.replace(/\D/g, "").length < 10)
            newErrors.phone = t("form_error_phone")

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleSubmit = async () => {
        if (!validateForm()) return

        setFormData(prev => ({ ...prev, isLoadingResponse: true }))

        const response = await sendRoadTransportEmail(formData)

        if (response.success) {
            trackLead('lp_transporte_rodoviario', { type: formData.type, origin: formData.origin, destination: formData.destination })
            setFormData(DEFAULT_FORM_DATA)
            setErrors({})
        }

        showAlert(response.message, response.success ? 'success' : 'error')
        setFormData(prev => ({ ...prev, isLoadingResponse: false }))
    }

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
            <div id="home" className="sectionOneBg">
                <video
                    autoPlay
                    muted
                    loop
                    playsInline
                    controlsList="disabled"
                    src={'https://singlec.com.br/imagens-publicas/gh_publicitario.mp4'}
                    preload="auto"
                ></video>
                <div className="sectionOne">
                    {/* <div className={`gptw ${isVisible ? 'visible' : ''}`} >
                        <img src={gptw} alt="" width={'60px'} height={'102px'}/>
                    </div> */}
                    <div className={`text ${isVisible ? 'visible' : ''}`}>
                        <h1>{t("lp5_hero_title")}</h1>
                        <h5>{t("lp5_hero_subtitle")}</h5>
                        <a
                            className="button"
                            href={"https://wa.me/5547992246105?text=" + buildWhatsAppText(message)}
                            target="_blank"
                            rel="noreferrer"
                            reloadDocument
                            onClick={() => trackWhatsApp("lp_transporte_rod_hero")}
                        >
                            <button>{t("lp5_cta_button")}</button>
                        </a>
                    </div>
                    <CForm id="transporteRodoviarioForm" className={`${isVisible ? 'visible' : ''}`}>
                        <div>
                        <CFormInput
                            type="text"
                            maxLength={80}
                            minLength={3}
                            value={formData.name}
                            onChange={(e) => {
                                setFormData(prev => ({ ...prev, name: e.target.value }))
                                setErrors(prev => ({ ...prev, name: undefined }))
                            }}
                            className="me-2"
                            placeholder={t("lp5_form_name")}
                            invalid={!!errors.name}
                        ></CFormInput>
                        {errors.name && <CFormText className="text-danger">{errors.name}</CFormText>}
                        <CFormInput
                            type="email"
                            autoComplete='off'
                            maxLength={60}
                            className="me-2"
                            placeholder={t("lp5_form_email")}
                            value={formData.email}
                            onChange={(e) => {
                                setFormData(prev => ({ ...prev, email: e.target.value }))
                                setErrors(prev => ({ ...prev, email: undefined }))
                            }}
                            invalid={!!errors.email}
                        ></CFormInput>
                        {errors.email && <CFormText className="text-danger">{errors.email}</CFormText>}
                        <CFormInput
                            type="phone"
                            autoComplete='off'
                            maxLength={15}
                            minLength={15}
                            onChange={(e) => {
                                formatPhoneValue(e)
                                setErrors(prev => ({ ...prev, phone: undefined }))
                            }}
                            className="me-2"
                            placeholder={t("lp5_form_phone")}
                            value={formData.phone}
                            invalid={!!errors.phone}
                        ></CFormInput>
                        {errors.phone && <CFormText className="text-danger">{errors.phone}</CFormText>}
                        <CFormInput
                            type="text"
                            maxLength={500}
                            minLength={3}
                            value={formData.enterprise}
                            onChange={(e) => setFormData(prev => ({ ...prev, enterprise: e.target.value }))}
                            className="me-2"
                            placeholder={t("lp5_form_enterprise")}
                        ></CFormInput>
                        <CFormInput
                            type="text"
                            maxLength={500}
                            minLength={3}
                            value={formData.type}
                            onChange={(e) => setFormData(prev => ({ ...prev, type: e.target.value }))}
                            className="me-2"
                            placeholder={t("lp5_form_type")}
                        ></CFormInput>
                        <CFormInput
                            type="text"
                            maxLength={500}
                            minLength={3}
                            value={formData.weight}
                            onChange={(e) => setFormData(prev => ({ ...prev, weight: e.target.value }))}
                            className="me-2"
                            placeholder={t("lp5_form_weight")}
                        ></CFormInput>
                        <CFormInput
                            type="text"
                            maxLength={500}
                            minLength={3}
                            value={formData.value}
                            onChange={(e) => setFormData(prev => ({ ...prev, value: e.target.value }))}
                            className="me-2"
                            placeholder={t("lp5_form_value")}
                        ></CFormInput>
                        <CFormInput
                            type="text"
                            maxLength={500}
                            minLength={3}
                            value={formData.origin}
                            onChange={(e) => setFormData(prev => ({ ...prev, origin: e.target.value }))}
                            className="me-2"
                            placeholder={t("lp5_form_origin")}
                        ></CFormInput>
                        <CFormInput
                            type="text"
                            maxLength={500}
                            minLength={3}
                            value={formData.destination}
                            onChange={(e) => setFormData(prev => ({ ...prev, destination: e.target.value }))}
                            className="me-2"
                            placeholder={t("lp5_form_destination")}
                        ></CFormInput>
                        <CButton className="mt-4" onClick={handleSubmit} disabled={formData.isLoadingResponse}>
                            {formData.isLoadingResponse ? t("lp5_form_sending") : t("lp5_form_send")}
                        </CButton>
                        </div>
                    </CForm>
                </div>
                <img className={`arrow5 ${isVisible ? 'visible' : ''}`}  src={arrow2} width={'100px'} alt="" />
                <img className={`arrow6 ${isVisible ? 'visible' : ''}`} src={arrow2} width={'100px'} alt="" />
                <img className={`arrow7 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
                <img className={`arrow8 ${isVisible ? 'visible' : ''}`} src={arrow} alt="" />
            </div>
        </VisibilitySensor>
    )
}

export default SectionOne;
